import React from 'react';
import store from '../../store/Store';
import actions from '../../actions/Actions';

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import FormatItalicIcon from '@material-ui/icons/FormatItalic'
import FormatBoldIcon from '@material-ui/icons/FormatBold'
import DoneIcon from '@material-ui/icons/Done'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import SlideshowIcon from '@material-ui/icons/Slideshow'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation'
import ImageIcon from '@material-ui/icons/Image'
import CircularProgress from '@material-ui/core/CircularProgress'

import './editorMediaImage.scss'

type editorMediaImageState = {
  article: any;
  navigation: any;
  row: any;
  column: any;
  id: any;
  sX: any;
  sY: any;
  csX: any;
  csY: any;
  mouseDown: any;
  link: any;
  uploading: any;
}

type editorMediaImageProps = {
  article: any;
  navigation: any;
  row: any;
  column: any;
  id: any;
}

let draggable

class EditorMediaImage extends React.Component<editorMediaImageProps, editorMediaImageState> {

  constructor(props) {
    super(props)

    this.state = {
      article: props.article,
      navigation: props.navigation,
      row: props.row,
      column: props.column,
      id: props.id,
      sX: 0,
      sY: 0,
      csX: 0,
      csY: 0,
      link: '',
      mouseDown: false,
      uploading: false
    }
  }

  componentDidMount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })

    const { 
      article, 
      row, 
      column
    } = this.state

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.media.map((item, index, array) => {
        // console.log(item.type)
        // console.log(item.id)
        item.row === row && item.column === column ? null : null
        // document.getElementById(article.media[i].id).addEventListener('dragenter', this.onDragEnter.bind(this), false)
        // document.getElementById(article.media[i].id).addEventListener('dragleave', this.onDragLeave.bind(this), false)
        // document.getElementById(article.media[i].id).addEventListener('dragover', this.onDragOver.bind(this), false)
        // document.getElementById(article.media[i].id).addEventListener('drop', this.onDrop.bind(this), false)
      })
    })
  }

  onClick = (event) => {
    // console.log('Clicked')
  }

  onDragEnter = (event) => {
    // console.log('DRAG ENTER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDragLeave = (event) => {
    // console.log('DRAG LEAVE')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDragOver = (event) => {
    // console.log('DRAG OVER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDrop = (event) => {
    // console.log('DROP')

    // console.log(event)
    // console.log(event.currentTarget)
    // console.log(event.currentTarget)
    // console.log(event.target)
    // console.log(event.target.id)
    // console.log(event.target.files)
    // console.log(event.currentTarget)
    // console.log(event.dataTransfer.files)
    // console.log(event.dataTransfer)

    let targetId = event.target.id

    // console.log(targetId)

    event && event.dataTransfer && event.dataTransfer.files ? this.uploadImage(event.dataTransfer.files[0]) : this.uploadImage(event.target.files[0])

    // event.target.files ? console.log('File was opened') : console.log('File was NOT opened')
    // event && event.dataTransfer && event.dataTransfer.files ? console.log('File was dragged') : console.log('File was NOT dragged')

    event.preventDefault()
    event.stopPropagation()

    let reader = new FileReader()
    event && event.dataTransfer && event.dataTransfer.files ? reader.readAsDataURL(event.dataTransfer.files[0]) : reader.readAsDataURL(event.target.files[0])
    reader.onloadend = function() {
      let img = document.createElement('img')
      img.src = reader.result as string

      // console.log(img)

      img.style.width = '100%'
      img.style.height = '100%'
      document.getElementById(targetId).appendChild(img)
    }
  }

  onDragImage = (event) => {
    // console.log('Drag Event')
    const { sX, sY, csX, csY, mouseDown } = this.state

    // console.log(event.target.getBoundingClientRect())

    let rect = event.target.getBoundingClientRect()

    // console.log(csX, csY)
    // console.log(event.clientX, event.clientY)

    if (event.clientX === 0 && event.clientY === 0) {
      return
    }

    let cX = (event.clientX - rect.left) - csX
    let cY = (event.clientY - rect.top) - csY

    if (mouseDown) {
      console.log(cX, cY)
      console.log(sX, sY)

      this.setState({
        sX: sX + cX, 
        sY: sY + cY
      })
    }
  }

  onMouseMoveImage = (event) => {
    
  }

  onClickImage = (event) => {
    
  }

  onMouseUpImage = (event) => {
    // console.log('Mouse Up Event')
    // console.log(event.clientX, event.clientY)
    this.setState({
      mouseDown: false
    })
  }

  onMouseDownImage = (event) => {
    // console.log('Mouse Down Event')
    // console.log(event.clientX, event.clientY)

    let rect = event.target.getBoundingClientRect()

    // console.log(event.clientX - rect.left, event.clientY - rect.top)

    this.setState({
      csX: event.clientX - rect.left, 
      csY: event.clientY - rect.top,
      mouseDown: true
    })
  }

  onDragStartImage = (event) => {
    // console.log('Drag Start Event')
    draggable = event.target

    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/html', event.target.outerHTML);

    event.target.classList.add('draggable')
  }

  onDragEndImage = (event) => {
    // console.log('Drag End Event')
    event.target.classList.remove('draggable')

    this.setState({
      mouseDown: false
    })

    // console.log(this.state.sX, this.state.sY)
  }

  onDragEnterImage = (event) => {
    // console.log('Drag Enter Event')
  }

  onDragLeaveImage = (event) => {
    // console.log('Drag Leave Event')

    const { row, column, article, id, link, sX, sY } = this.state

    // console.log(link)
    // console.log(this.state.link)
    // console.log(this.state)

    this.setState({
      mouseDown: false
    })

    actions.articleActions.updateMedia({
      index: article.info.currentPage,
      row, 
      column,
      type: 1,
      id,
      content: {
        shiftX: sX,
        shiftY: sY
      }
    })
  }

  uploadImage = (image) => {
    // console.log(image)

    const { row, column, article, id } = this.state

    this.setState({
      uploading: true
    })

    const formData = new FormData()

    formData.append('image', image)
    formData.append('imageName', image.name)
    formData.append('imageSize', image.size)
    formData.append('imageType', image.type)

    // console.log(formData.getAll('image'))

    let link

    actions.uploadActions.uploadImage(formData).then((res) => {
      // console.log(res)
      // console.log(res.success)
      // console.log(res.returnCode)
      // console.log(res.returnMessage)
      // console.log(res.imageLink)

      actions.articleActions.updateMedia({
        index: article.info.currentPage,
        row, 
        column,
        type: 1,
        id,
        content: {
          link: res.imageLink
        }
      })

      this.setState({
        uploading: false
      })
    }).catch((err) => { 
      console.log(err) 

      this.setState({
        uploading: false
      })
    })
  }

  render() {
    const {
      article,
      navigation,
      row,
      column,
      sX,
      sY,
      uploading
    } = this.state

    let edit = false
    let preview = false
    let id = ''
    let link = ''
    let shiftX = sX
    let shiftY = sY

    // console.log(shiftX, shiftY)

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.edit && page.edit.map((item, index, array) => {
        return item.row === row && item.column === column ? edit = true : null
      })

      article.info.currentPage === page.index && page.preview && page.preview.map((item, index, array) => {
        return item.row === row && item.column === column ? preview = true : null
      })

      article.info.currentPage === page.index && page.preview && page.media.map((item, index, array) => {
        return item.row === row && item.column === column ? id = item.id : null
      })

      article.info.currentPage === page.index && (page.edit || page.preview) && page.media.map((item, index, array) => {
        return item.row === row && item.column === column ? link = item.content && item.content.link ? item.content.link : '' : null
        return item.row === row && item.column === column ? shiftX = item.content && item.content.shiftX ? item.content.shiftX : sX : null
        return item.row === row && item.column === column ? shiftY = item.content && item.content.shiftY ? item.content.shiftY : sY : null
      })
    })

    // console.log('EditorMediaImage')
    // console.log(row)
    // console.log(column)
    // console.log(edit)
    // console.log(preview)
    // console.log(id)
    // console.log(link)
    // console.log(shiftX)
    // console.log(shiftY)

    return (
      <div
        className='EditorMediaImage'
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        
        {
          edit && !article.preview ? (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0,
                overflow: 'hidden'
              }}
            >

              {
                link ? 
                  <img 
                    src={ link }
                    style={{
                      position: 'absolute',
                      top: shiftY + 'px',
                      left: shiftX + 'px',
                      cursor: 'move'
                    }}
                    onDrag={ (event) => { this.onDragImage(event) }}
                    onClick={ (event) => { this.onClickImage(event) }}
                    onMouseUp={ (event) => { this.onMouseUpImage(event) }}
                    onMouseDown={ (event) => { this.onMouseDownImage(event) }}
                    onDragStart={ (event) => { this.onDragStartImage(event) }}
                    onDragEnter={ (event) => { this.onDragEnterImage(event) }}
                    onDragLeave={ (event) => { this.onDragLeaveImage(event) }}
                    onDragEnd={ (event) => { this.onDragEndImage(event) }}
                    onMouseMove={ (event) => { this.onMouseMoveImage(event) }}
                    draggable
                  ></img>
                : <div
                    style={{
                      position: 'absolute',
                      width: 'calc(100% - 20px)',
                      height: 'calc(100% - 20px)',
                      border: '1px dashed rgba(0, 0, 0, 255)',
                      margin: '9px',
                      textAlign: 'center',
                      color: 'rgba(0, 0, 0, 255)'
                    }}
                    onDragEnter={ this.onDragEnter.bind(this) }
                    onDragLeave={ this.onDragLeave.bind(this) }
                    onDragOver={ this.onDragOver.bind(this) }
                    onDrop={ this.onDrop.bind(this) }
                  >
                    {
                      !uploading ?
                        <div
                          style={{
                            display: 'block',
                            position: 'absolute',
                            width: '120px',
                            height: '50px',
                            top: 'calc(50% - 25px)',
                            left: 'calc(50% - 60px)',
                            lineHeight: '50px',
                            cursor: 'pointer',
                            border: '1px dotted rgba(0, 0, 0, 255)'
                          }}
                          onClick={ this.onClick.bind(this) }
                        >
                          Drag 'N' Drop
                        </div>
                      :
                        <div
                          style={{
                            display: 'block',
                            position: 'absolute',
                            width: '120px',
                            height: '50px',
                            top: 'calc(50% - 25px)',
                            left: 'calc(50% - 60px)',
                            lineHeight: '50px',
                            cursor: 'pointer',
                            border: '1px dotted rgba(0, 0, 0, 255)'
                          }}
                        >
                          <CircularProgress />
                        </div>
                    }

                    <input 
                      type='file'
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer'
                      }}
                      onChange={ this.onDrop.bind(this) }
                    />
                  </div>
              }

              <IconButton
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0'
                }}
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ () => { actions.articleActions.removeEditCell({
                    index: article.info.currentPage,
                    row,
                    column
                  }) 
                }}
              >
                <Icon>
                  <DoneIcon />
                </Icon>
              </IconButton>
            </div>
          ) : preview || article.preview ? (
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                textAlign: 'center'
              }}
            >
              <img 
                src={ link }
                style={{
                  position: 'absolute',
                  top: shiftY + 'px',
                  left: shiftX + 'px'
                }}
              ></img>

              <IconButton
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0'
                }}
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ () => { actions.articleActions.removePreviewCell({
                    index: article.info.currentPage,
                    row,
                    column
                  }) 
                }}
              >
                <Icon>
                  <CancelPresentationIcon />
                </Icon>
              </IconButton>
            </div>
          ) : (
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                textAlign: 'center',
                backgroundColor: 'rgba(150, 150, 150, 255)'
              }}
            >
              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 75px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <ImageIcon />
                  </Icon>
                </IconButton>
              </div>

              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 25px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <SlideshowIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addEditCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <EditIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.removeMedia({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <DeleteForeverOutlinedIcon />
                  </Icon>
                </IconButton>
              </div>
            </div>
          )
        }

      </div>
    );
  }
}

export default EditorMediaImage;